import type React from 'react'
import type { JSX } from 'react'

import {
  AuthLayoutAlignItems,
  AuthLayoutBackgroundColors,
  AuthLayoutJustifyContent,
  AuthLayoutOverlayColors,
} from './AuthLayout.h'
import {
  AuthLayoutContent,
  AuthLayoutOverlayStyled,
  AuthLayoutStyled,
} from './AuthLayout.styled'

export interface IAuthLayoutProps {
  children: React.ReactNode
  posterUrl?: string
  justifyContent?: AuthLayoutJustifyContent
  alignItems?: AuthLayoutAlignItems
  isMobileVerticalAlignment?: boolean
  overlayEnabled?: boolean
  overlayWidth?: number
  overlayHeight?: number
  overlayHorizontalColor?: AuthLayoutOverlayColors
  overlayVerticalColor?: AuthLayoutOverlayColors
  background?: AuthLayoutBackgroundColors
  backgroundOpacity?: number
  backgroundOpacityTransitionDuration?: number
  paddingTop?: string
}

export const AuthLayout = ({
  children,
  posterUrl = '',
  justifyContent = AuthLayoutJustifyContent.Center,
  alignItems = AuthLayoutAlignItems.Center,
  overlayEnabled = false,
  overlayWidth = 0,
  overlayHeight = 0,
  overlayHorizontalColor = AuthLayoutOverlayColors.BANNER_HORIZONTAL_OVERLAY,
  overlayVerticalColor = AuthLayoutOverlayColors.BANNER_VERTICAL_OVERLAY,
  background = AuthLayoutBackgroundColors.BACKGROUND_DARK_APP,
  backgroundOpacity,
  backgroundOpacityTransitionDuration,
  paddingTop,
  isMobileVerticalAlignment,
}: IAuthLayoutProps): JSX.Element => (
  <AuthLayoutStyled
    posterUrl={posterUrl}
    background={background}
    backgroundOpacity={backgroundOpacity}
    backgroundOpacityTransitionDuration={backgroundOpacityTransitionDuration}
  >
    <AuthLayoutOverlayStyled
      overlayEnabled={overlayEnabled}
      overlayWidth={overlayWidth}
      overlayHeight={overlayHeight}
      overlayHorizontalColor={overlayHorizontalColor}
      overlayVerticalColor={overlayVerticalColor}
    />
    <AuthLayoutContent
      justifyContent={justifyContent}
      alignItems={alignItems}
      paddingTop={paddingTop}
      isMobileVerticalAlignment={isMobileVerticalAlignment}
    >
      {children}
    </AuthLayoutContent>
  </AuthLayoutStyled>
)

AuthLayout.displayName = 'AuthLayout'
